import { useState } from "react";
import styles from "./Hero.module.css";
import ObfuscatedEmail from "../ObfuscatedEmail";
import heroImg from "../../assets/images/image.png";

const Hero = () => {
    const [isPhoneModalOpen, setIsPhoneModalOpen] = useState(false);

    const handlePhoneClick = (e) => {
        e.preventDefault();
        setIsPhoneModalOpen(true);
    };

    const closeModal = () => {
        setIsPhoneModalOpen(false);
    };

    return (
        <section className={styles.heroSection} style={{ backgroundImage: `url(${heroImg})` }}>
            <div className={styles.heroContainer}>
                {/* Left Content */}
                <div className={styles.heroContent}>
                    <p className={styles.tag}>Serving Southern California with care you can trust</p>
                    <h1 className={styles.heading}>
                        Home Health Care <br></br>Right Where You Belong
                    </h1>
                    <p className={styles.description}>
                        All For You Home Health Care provides professional, personalized medical care in the comfort of your home. Our experienced
                        team supports patients and families with dignity, respect, and clinical excellence - every step of the way.
                    </p>
                    <div className={styles.buttonGroup}>
                        <a href="/contact" className={styles.primaryButton}>
                            Refer a Patient
                            <svg
                                className={styles.buttonArrow}
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </a>
                        <a href="/services" className={styles.secondaryButton}>
                            View All Services
                            <svg
                                className={styles.buttonArrow}
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </a>
                    </div>
                </div>
            </div>

            {/* Contact Cards */}
            <div className={styles.contactCards}>
                <div className={styles.card}>
                    <div className={styles.iconWrapper}>
                        <svg className={styles.icon} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M20.01 15.38C18.78 15.38 17.59 15.18 16.48 14.82C16.13 14.7 15.74 14.79 15.47 15.06L13.9 17.03C11.07 15.68 8.42 13.13 7.01 10.2L8.96 8.54C9.23 8.26 9.31 7.87 9.2 7.52C8.83 6.41 8.64 5.22 8.64 3.99C8.64 3.45 8.19 3 7.65 3H4.19C3.65 3 3 3.24 3 3.99C3 13.28 10.73 21 20.01 21C20.72 21 21 20.37 21 19.82V16.37C21 15.83 20.55 15.38 20.01 15.38Z"
                                fill="currentColor"
                            />
                        </svg>
                    </div>
                    <div className={styles.cardContent}>
                        <h3 className={styles.cardTitle}>Call us</h3>
                        <p className={styles.cardInfo}>
                            Office: (818) 939-1031
                            <br />
                            Phone: (760) 424-2000
                            <br />
                            Fax: (818) 949-1032
                        </p>
                        <button onClick={handlePhoneClick} className={styles.cardLink}>
                            Give us a call →
                        </button>
                    </div>
                </div>

                <div className={styles.card}>
                    <div className={styles.iconWrapper}>
                        <svg className={styles.icon} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z"
                                fill="currentColor"
                            />
                        </svg>
                    </div>
                    <div className={styles.cardContent}>
                        <h3 className={styles.cardTitle}>Email us</h3>
                        <ObfuscatedEmail plain className={styles.cardInfo} />
                        <ObfuscatedEmail className={styles.cardLink}>
                            Send us an email →
                        </ObfuscatedEmail>
                    </div>
                </div>

                <div className={styles.card}>
                    <div className={styles.iconWrapper}>
                        <svg className={styles.icon} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2ZM12 11.5C10.62 11.5 9.5 10.38 9.5 9C9.5 7.62 10.62 6.5 12 6.5C13.38 6.5 14.5 7.62 14.5 9C14.5 10.38 13.38 11.5 12 11.5Z"
                                fill="currentColor"
                            />
                        </svg>
                    </div>
                    <div className={styles.cardContent}>
                        <h3 className={styles.cardTitle}>Visit us</h3>
                        <p className={styles.cardInfo}>
                            40 N. Altadena Dr. Ste 200J
                            <br />
                            Pasadena, CA 91107
                        </p>
                        <a href="https://maps.app.goo.gl/MP6fUPqp6gZdupjt8" target="_blank" rel="noopener noreferrer" className={styles.cardLink}>
                            View our locations →
                        </a>
                    </div>
                </div>
            </div>

            {/* Phone Selection Modal */}
            {isPhoneModalOpen && (
                <div className={styles.modalOverlay} onClick={closeModal}>
                    <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                        <div className={styles.modalHeader}>
                            <h3 className={styles.modalTitle}>Choose a number to call</h3>
                            <button className={styles.modalClose} onClick={closeModal}>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M18 6L6 18M6 6L18 18"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </button>
                        </div>
                        <div className={styles.modalBody}>
                            <a href="tel:8189391031" className={styles.phoneOption}>
                                <div className={styles.phoneIconWrapper}>
                                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M20.01 15.38C18.78 15.38 17.59 15.18 16.48 14.82C16.13 14.7 15.74 14.79 15.47 15.06L13.9 17.03C11.07 15.68 8.42 13.13 7.01 10.2L8.96 8.54C9.23 8.26 9.31 7.87 9.2 7.52C8.83 6.41 8.64 5.22 8.64 3.99C8.64 3.45 8.19 3 7.65 3H4.19C3.65 3 3 3.24 3 3.99C3 13.28 10.73 21 20.01 21C20.72 21 21 20.37 21 19.82V16.37C21 15.83 20.55 15.38 20.01 15.38Z"
                                            fill="currentColor"
                                        />
                                    </svg>
                                </div>
                                <div className={styles.phoneDetails}>
                                    <span className={styles.phoneLabel}>Office</span>
                                    <span className={styles.phoneNumber}>(818) 939-1031</span>
                                </div>
                            </a>
                            <a href="tel:7604242000" className={styles.phoneOption}>
                                <div className={styles.phoneIconWrapper}>
                                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M20.01 15.38C18.78 15.38 17.59 15.18 16.48 14.82C16.13 14.7 15.74 14.79 15.47 15.06L13.9 17.03C11.07 15.68 8.42 13.13 7.01 10.2L8.96 8.54C9.23 8.26 9.31 7.87 9.2 7.52C8.83 6.41 8.64 5.22 8.64 3.99C8.64 3.45 8.19 3 7.65 3H4.19C3.65 3 3 3.24 3 3.99C3 13.28 10.73 21 20.01 21C20.72 21 21 20.37 21 19.82V16.37C21 15.83 20.55 15.38 20.01 15.38Z"
                                            fill="currentColor"
                                        />
                                    </svg>
                                </div>
                                <div className={styles.phoneDetails}>
                                    <span className={styles.phoneLabel}>Phone</span>
                                    <span className={styles.phoneNumber}>(760) 424-2000</span>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            )}
        </section>
    );
};

export default Hero;
